import {
  IonContent, IonImg, IonPage, IonText,
} from '@ionic/react';
import classNames from 'classnames';
import { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';

import articlesImg from '@/assets/icons/reading.svg';
import webinarImg from '@/assets/icons/video.svg';
import Banner from '@/components/common/Banner';
import { BannerType } from '@/components/common/Banner/Banner';
import LearningCard from '@/components/learning/LearningCard/LearningCard';
import { ROUTES_PATH } from '@/constants';
import useMediaQuery, { Breakpoint } from '@/hooks/useMediaQuery';
import {
  ArticleResponse,
  VideoItems,
  VideoResponse,
} from '@/interfaces/LearningInterface/LearningInterface';

import styles from './Learning.module.scss';

export default function Learning() {
  const history = useHistory();

  const [articleList, setarticleList] = useState<ArticleResponse[]>([]);
  const [webinarList, setwebinarList] = useState<VideoItems[]>([]);

  const isMobileD = useMediaQuery(Breakpoint.Mobile);
  const isTabletMini = useMediaQuery(Breakpoint.TabletMini);
  const isTablet = useMediaQuery(Breakpoint.Tablet);
  const isDesktop = useMediaQuery(Breakpoint.Tablet);

  const [isMobile, setIsMobile] = useState(!isTablet && !isDesktop);

  useEffect(() => {
    setIsMobile(!isTablet && !isDesktop && !isTabletMini && !isMobileD);
  }, [isTablet, isDesktop, isTabletMini]);

  const getArticlesFromApi = async () => {
    try {
      const response = await fetch(
        'https://pepperfinance.es/wp-json/wp/v2/posts/?per_page=4&categories=29&orderby=modified&order=desc',
      );
      const responseJson = await response.json();
      setarticleList(responseJson);
    } catch (error) {
      console.error(error);
    }
  };

  const getWebinarsFromApi = async () => {
    try {
      const response = await fetch(
        'https://www.googleapis.com/youtube/v3/playlistItems?key=AIzaSyAb8W--TEpkE3oqvwi7XOXGznIh7vHK3_g&playlistId=PLP9ms8Ry_5Oa7nnk6BTyC7N7tmEM2-ecy&part=id,snippet,contentDetails,status',
      );
      const responseJson: VideoResponse = await response.json();
      setwebinarList(responseJson.items);
    } catch (error) {
      console.error(error);
    }
  };

  const handleViewAll = (route: ROUTES_PATH) => {
    if (isMobile) {
      return history.push(ROUTES_PATH.ALL_RESOURCES_MOBILE, { route });
    }
    history.push(route);
  };

  useEffect(() => {
    getArticlesFromApi();
    getWebinarsFromApi();
  }, []);

  return (
    <IonPage className={styles.learningPageWrapper}>
      <IonContent>
        <Banner type={BannerType.LEARNING} />
        <div className={styles.learningPageContent}>
          <div className={styles.mobileHeader}>
            <IonText className={styles.titleText}>Formación</IonText>
          </div>
          <div className={styles.learningPage}>

            <div className={styles.titleWrapper}>
              <IonText className={styles.titleText}>Formación</IonText>
            </div>
            <div className={styles.headerDivider} />

            <div className={classNames(styles.submenuWrapper, styles.webinarSectionTitle)}>
              <IonText className={styles.submenuText}>
                {' '}
                <IonImg src={webinarImg} className={styles.submenuImg} />
                {' '}
                Webinars
              </IonText>
              <div
                onClick={() => {
                  handleViewAll(ROUTES_PATH.WEBINAR_ALL);
                }}
                className={styles.seeAllText}
              >
                Ver todos
              </div>
            </div>
            <div className={styles.webinarsSection}>
              <div className={styles.webinarsWrapper}>
                {/* <LearningCard articleList={articleList} /> */}
                {webinarList.map((webinar: VideoItems, index) => (
                  <LearningCard
                    key={index}
                    title={webinar?.snippet?.title}
                    imgUrl={webinar?.snippet?.thumbnails?.medium?.url}
                    smallTitle
                    cardClick={() => {
                      history.push({
                        pathname: `${ROUTES_PATH.WEBINAR_DETAIL}/${webinar?.id}`,
                        state: webinar,
                      });
                    }}
                  />
                ))}
              </div>
            </div>
            <div className={styles.submenuWrapper}>
              <IonText className={styles.submenuText}>
                <IonImg src={articlesImg} className={styles.submenuImg} />
                Artículos
              </IonText>
              <div
                onClick={() => {
                  handleViewAll(ROUTES_PATH.ARTICLE_ALL);
                }}
                className={styles.seeAllText}
              >
                Ver todos
              </div>
            </div>
            <div className={styles.articlesSection}>
              <div className={styles.articlesWrapper}>
                {articleList.map((article: ArticleResponse, index) => (
                  <LearningCard
                    key={index}
                    title={article?.title?.rendered}
                    subtitle={article?.excerpt?.rendered}
                    imgUrl={article?.fimg_url}
                    description={article?.yoast_head_json?.og_description}
                    cardClick={() => {
                      history.push({
                        pathname: `${ROUTES_PATH.ARTICLE_DETAIL}/${article?.id}`,
                        state: article,
                      });
                    }}
                  />
                ))}
              </div>
            </div>
          </div>
        </div>
      </IonContent>
    </IonPage>
  );
}
